export default __webpack_public_path__ + "static/media/p1-8.9b35a9fc.png";